import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = {
  class: "text pad20",
  style: {"color":"#696969"}
}
const _hoisted_3 = { class: "fl mr20" }
const _hoisted_4 = { class: "fs13 fw600 ddgrey text-left pad10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "mt20"
}
const _hoisted_7 = { style: {"padding-left":"40px"} }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt7 ml5 mr5" }, "~", -1)
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = { class: "w100" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "w15 fl",
  style: {}
}, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "w80 fl"
}
const _hoisted_16 = { class: "pad10 mb20" }
const _hoisted_17 = { class: "fl mr20" }
const _hoisted_18 = { class: "fs24 fw600 arial" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "件が選択されています", -1)
const _hoisted_20 = {
  key: 0,
  class: "fl mt8"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "mr5" }, "一括", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "dli_circle skyblue" }, null, -1)
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "mr5" }, "一括", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "dli_close pink" }, null, -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = {
  key: 0,
  class: "fl pad15",
  style: {"height":"50px","width":"50px"}
}
const _hoisted_29 = {
  key: 1,
  class: "fl pad15",
  style: {"height":"50px","width":"50px"}
}
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_32 = {
  key: 1,
  class: "w80 fl"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SelectTag, {
          name: "fix_vote_type",
          id: "fix_vote_type",
          class: "fs14 roundForm",
          style: {"min-width":"360px","height":"50px"},
          options: _ctx.SelectUtil.suggestedDatesDisplayType.map(e => e.name),
          defaultOption: _ctx.defaultDisplayType(),
          onSelectValue: _ctx.selectDisplayType,
          isDisabled: false
        }, null, 8, ["options", "defaultOption", "onSelectValue"])
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.selectedDiscription()), 1),
      _hoisted_5,
      (_ctx.vrm.suggested_dates_display_type == `period`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Dropdown, {
                class: "form-group fl",
                style: {"width":"140px"}
              }, {
                dropdown: _withCtx(() => [
                  _createElementVNode("li", null, [
                    _createVNode(_component_DatePicker, {
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startDate) = $event)),
                      format: "yyyy/MM/dd",
                      "today-btn": false,
                      "clear-btn": false
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control dropdown-toggle",
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.startDate]
                    ])
                  ])
                ]),
                _: 1
              }),
              _hoisted_9,
              _createVNode(_component_Dropdown, {
                class: "form-group fl",
                style: {"width":"140px"}
              }, {
                dropdown: _withCtx(() => [
                  _createElementVNode("li", null, [
                    _createVNode(_component_DatePicker, {
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event)),
                      format: "yyyy/MM/dd",
                      "today-btn": false,
                      "clear-btn": false
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control dropdown-toggle",
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endDate) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.endDate]
                    ])
                  ])
                ]),
                _: 1
              }),
              _hoisted_11
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        (_ctx.suggestedDates)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.selectedLength), 1),
                    _hoisted_19
                  ]),
                  (_ctx.vrm.suggested_dates_display_type == `select_self`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("label", {
                          class: "fl label skyblueBorder fs11 pointer mr3",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args)))
                        }, _hoisted_23),
                        _createElementVNode("label", {
                          class: "fl label pinkBorder fs11 pointer",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deselectAll && _ctx.deselectAll(...args)))
                        }, _hoisted_26)
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_27
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestedDates, (suggestedDate, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "w100",
                    key: `${suggestedDate.start_time}${suggestedDate.end_time}${suggestedDate.selected}${_ctx.vrm.suggested_dates_display_type}`
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`fl pad15 fw600 ${index % 2 == 0 ? `yellowBg` : `llgreyBg`}`),
                      style: {"width":"280px","height":"50px"}
                    }, _toDisplayString(suggestedDate.jp_format), 3),
                    (_ctx.vrm.suggested_dates_display_type == `select_self`)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createVNode(_component_CheckboxTag, {
                            value: ``,
                            name: `use_noindex`,
                            checked: suggestedDate.selected,
                            prefix: `use_noindex`,
                            onClickCheckbox: ($event: any) => (_ctx.clickSuggestDate(suggestedDate, index)),
                            style: {"margin-left":"1px","margin-right":"7px"}
                          }, null, 8, ["checked", "onClickCheckbox"])
                        ]))
                      : _createCommentVNode("", true),
                    ([`all`, `period`].includes(_ctx.vrm.suggested_dates_display_type))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          (
                                        [`all`].includes(_ctx.vrm.suggested_dates_display_type) ||
                                        (_ctx.vrm.suggested_dates_display_start_at < suggestedDate.start_time &&
                                            _ctx.vrm.suggested_dates_display_end_at > suggestedDate.start_time)
                                    )
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.$getAssetImageUrl(`/assets/icons/circle_bold.png`),
                                width: "24"
                              }, null, 8, _hoisted_30))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_31
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createVNode(_component_RoomsLoader)
            ])),
        _hoisted_33
      ])
    ])
  ]))
}